/**
 * What the 2FA page does with a verify or resend error (#148).
 *
 * Kept free of imports so its unit test can load the compiled module directly.
 */

/** Errors after which the 2FA challenge is gone: only a new sign-in helps. */
const CHALLENGE_GONE = new Set(['CHALLENGE_EXPIRED', 'TOO_MANY_ATTEMPTS']);

export type TwofaErrorAction =
  | { kind: 'sign-in-again'; notice: string }
  | { kind: 'show'; message: string };

export function twofaErrorAction(code: string, message: string): TwofaErrorAction {
  if (CHALLENGE_GONE.has(code)) {
    return { kind: 'sign-in-again', notice: `${message}.` };
  }
  if (code === 'EXPIRED') {
    // The code lapsed but the challenge is still open: a new code helps.
    return { kind: 'show', message: 'Your code has expired. Use "Resend Code" to get a new one.' };
  }
  return { kind: 'show', message };
}
